module.exports = __webpack_public_path__ + "img/mueblum3.39a24496.webp";